<div class="section-toggle">
  <mat-button-toggle-group [(value)]="displaySection" [hideSingleSelectionIndicator]="true">
    <mat-button-toggle [value]="DISPLAY_SECTION_OPTIONS_ENUM.ACTIVES">ATIVOS</mat-button-toggle>
    <mat-button-toggle [value]="DISPLAY_SECTION_OPTIONS_ENUM.PAST">ENCERRADOS</mat-button-toggle>
  </mat-button-toggle-group>
</div>
<div class="container-fluid p-3">
  @switch (displaySection) {
    @case (DISPLAY_SECTION_OPTIONS_ENUM.ACTIVES) {
      <div class="favorites-section">
        <div class="title-area">
          <h2>Eventos Ativos</h2>
        </div>

        <div class="events-area">
          @if (events) {
            @for (event of events; track event.id) {
              <app-event-card [event]="event" [isProducerArea]="false" />
            } @empty {
              <p>Você ainda não possui nenhum evento favoritado!</p>
            }
          } @else {
            <p-skeleton height="282px" />
            <p-skeleton height="282px" />
            <p-skeleton height="282px" />
            <p-skeleton height="282px" />
          }
        </div>

        <div class="action-area">
          @if (meta) {
            <app-button
              (btnClick)="loadMoreActiveEvents()"
              styleType="clean"
              [disabled]="meta.current_page >= meta.total_pages">
              <i class="pi pi-plus"></i>
              Carregar mais
            </app-button>
          }
        </div>
      </div>
    }
    @case (DISPLAY_SECTION_OPTIONS_ENUM.PAST) {
      <div class="favorites-section">
        <div class="title-area">
          <h2>Eventos Encerrados</h2>
        </div>

        <div class="events-area">
          @if (pastEvents) {
            @for (event of pastEvents; track event.id) {
              <app-event-card [event]="event" [isProducerArea]="false" />
            } @empty {
              <p>Você ainda não possui nenhum evento favoritado!</p>
            }
          } @else {
            <p-skeleton height="282px" />
            <p-skeleton height="282px" />
            <p-skeleton height="282px" />
            <p-skeleton height="282px" />
          }
        </div>

        <div class="action-area">
          @if (pastMeta) {
            <app-button
              (btnClick)="loadMorePastEvents()"
              styleType="clean"
              [disabled]="pastMeta.current_page >= pastMeta.total_pages">
              <i class="pi pi-plus"></i>
              Carregar mais
            </app-button>
          }
        </div>
      </div>
    }
    @default {
      <p>Opção não reconhecida</p>
    }
  }
</div>
